"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Configuration {
    constructor(token, options = {}) {
        let config = options.notifications || {};
        const region = config.region || options.region || 'us1';
        const defaultUrl = `https://ers.${region}.twilio.com/v1/registrations`;
        this.registrarUrl = config.ersUrl || defaultUrl;
        this._token = token;
    }
    updateToken(token) {
        this._token = token;
    }
    get token() {
        return this._token;
    }
}
exports.Configuration = Configuration;
